<form action="post" [class.isLoading]="isLoading()">
  <abc-form #CompanyRoleForm id="form" [(formData)]="company" [colCount]="1">
    <dxi-item [isRequired]="true">
      <abc-select-box
        class="drop-down-style"
        valueExpr="Id"
        displayExpr="Name"
        [stylingMode]="'outlined'"
        [width]="'100%'"
        [(value)]="company.ParentId"
        [dataSource]="companies()"
        [label]="res('Ubt-CreateStaffMembers-Company')+' *'"
        [labelMode]="'floating'"
        (onValueChanged)="updateName($event)"
        [validationMessagePosition]="'bottom'"
        [validationMessageMode]="'always'"
        [searchEnabled]="true"
      >
      </abc-select-box>
      <dxi-validation-rule 
        type="required" 
        [message]="res('Ubt-CreateStaffMembers-Company') + ' is required'">
      </dxi-validation-rule>
      <dxi-validation-rule 
        type="custom"
        [validationCallback]="validateCompanyIsNotAdded"
        [message]="res('Ubt-CreateStaffMembers-Company-Already-Exists')">
      </dxi-validation-rule>
    </dxi-item>
    <dxi-item [isRequired]="true">
      <abc-select-box
        class="drop-down-style"
        valueExpr="Value"
        displayExpr="Description"
        [stylingMode]="'outlined'"
        [width]="'100%'"
        [(value)]="company.Position"
        [dataSource]="roles()"
        [label]="res('Ubt-CreateStaffMembers-Role')+' *'"
        [labelMode]="'floating'"
        [validationMessagePosition]="'bottom'"
        [searchEnabled]="true"
        [validationMessageMode]="'always'"
      >
      </abc-select-box>
      <dxi-validation-rule 
        type="required" 
        [message]="res('Ubt-CreateStaffMembers-Role') + ' is required'">
      </dxi-validation-rule>
    </dxi-item>
    <dxi-item>
    <div fxLayout="column" fxLayoutGap="5px">
      <div fxFlex="20" fxLayoutAlign="end">
        <abc-button  icon="add" class="add-button-style" (onClick)="addRow()">
        </abc-button>
      </div>
      <abc-grid
        [height]="'200px'"
        [dataSource]="addressPerson()"
        [showBorders]="true"
        [selectionMode]="'single'"
        [showColumnLines]="false"
        [filterPanel]="false"
        [rowAlternationEnabled]="false"
        [searchPanel]="false"
        [showRowLines]="false"
        [columns]="columnsHeader()"
        [editing]="{
          allowUpdating: true,
          allowDeleting: true,
          mode: 'row',
          useIcons: true,
          confirmDelete: false
        }"
        (onEditingStart)="refreshColumns(true)"
        (onEditCanceled)="refreshColumns(false)"
        (onSaved)="refreshColumns(false)"
        (onRowUpdating)="updateCompanies($event)"
        (onRowRemoving)="deleteCompanies($event)"
        (onRowPrepared)="onRowPrepared($event)"
      >
      </abc-grid>
    </div>
    </dxi-item>
    <dxi-item itemType="group" [cssClass]="'form-buttons-container'">
      <abc-button
        class="submit-button"
        [text]="res('Ubt-CreateStaffMembers-Associate')"
        type="submit"
        [disabled]="!isAssociateValid()"
        (click)="persistAssociatedCompanies()"
      ></abc-button>
      <abc-button
        class="cancel-button"
        [text]="res('Ubt-CreateMeasure-Cancel')"
        type="submit"
        (click)="closePopup()"
      ></abc-button>
    </dxi-item>
  </abc-form>
</form>
@if (isLoading()) {
  <ubt-loader></ubt-loader>
}